import { FileText, Search, Bot, TrendingUp } from 'lucide-react';
import { type AITaskType } from '@/hooks/useAI';

// Contagem de prazos fica na Calculadora de Prazos: a IA não calcula datas de vencimento.
export const assistants = [
  {
    id: 'case_analysis' as AITaskType,
    title: 'Análise de Processos',
    description: 'Riscos, pontos críticos e próximos passos',
    icon: TrendingUp,
  },
  {
    id: 'document_generation' as AITaskType,
    title: 'Minutas',
    description: 'Rascunhos de petições e contratos',
    icon: FileText,
  },
  {
    id: 'legal_research' as AITaskType,
    title: 'Pesquisa Jurídica',
    description: 'Legislação e termos de busca',
    icon: Search,
  },
  {
    id: 'general' as AITaskType,
    title: 'Assistente Geral',
    description: 'Dúvidas e tarefas do escritório',
    icon: Bot,
  },
];
